import { createRoot } from "react-dom/client";
import { AboutPage } from "./pages/AboutPage";
import { LoginPage } from "./pages/LoginPage";
import "./styles.css";

const page = window.location.pathname === "/login" ? <LoginPage /> : <AboutPage />;

createRoot(document.getElementById("root")!).render(page);
